import { render, staticRenderFns } from "./SimpleUploadImage.vue?vue&type=template&id=1a7c8b3d&scoped=true&"
import script from "./SimpleUploadImage.vue?vue&type=script&lang=ts&"
export * from "./SimpleUploadImage.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleUploadImage.vue?vue&type=style&index=0&id=1a7c8b3d&lang=scss&scoped=true&"
import style1 from "./SimpleUploadImage.vue?vue&type=style&index=1&id=1a7c8b3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7c8b3d",
  null
  
)

export default component.exports